import React, { useMemo } from "react"

function Separator({
  type = "horizontal",
  gap = 16,
  color = "#F1F0F3",
  thickness = 1,
  style = {},
}) {
  const defaultStyle = useMemo(() => {
    if (type === "horizontal") {
      return {
        marginTop: gap,
        marginBottom: gap,
        height: thickness,
        backgroundColor: color,
      }
    }
    return {
      width: thickness,
      maringLeft: gap,
      marginRight: gap,
      backgroundColor: color,
    }
  }, [type, gap])
  return <div style={{ ...defaultStyle, ...style }} />
}

export default Separator
